import { PATH, PAYMENT_STATUS, STORAGE_KEY } from '@/constants';
import { API_ENDPOINTS } from '@/constants/api-endpoints';
import { apiInstance, handleShowError } from '@/utils';
import { toast } from 'react-toastify';
import { getAskIotUserDetails } from './user';

export const logout = async () => {
  const response = await fetch(API_ENDPOINTS.LOGOUT, {
    method: 'POST',
  });
  if (response.status === 200) {
    window.localStorage.removeItem(STORAGE_KEY.ACCESS_TOKEN);
    window.location.href = PATH.LOGIN;
  } else {
    handleShowError('');
  }
};

export const validateEmail = async (email: string): Promise<{ valid: string }> => {
  const res = await apiInstance({
    method: 'POST',
    url: API_ENDPOINTS.validateEmail,
    data: {
      email,
    },
  });

  return res.data;
};

export const validateUserAccess = async (
  accessToken: string,
): Promise<{ accessible: boolean } | undefined> => {
  // Legacy access checks removed. Now always returns accessible: true if accessToken is present.
  if (accessToken) {
    return { accessible: true };
  }
  return { accessible: false };
};
